<img [src]="image.original_url" alt="" />
